/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FixedWingLinesResponse } from '../../models/fixed-wing-lines-response';
import { MoveFixedWingLineCrewRequest } from '../../models/move-fixed-wing-line-crew-request';

export interface MoveFixedWingLineCrew$Params {

/**
 * Source line id.
 */
  id: number;
      body: MoveFixedWingLineCrewRequest
}

export function moveFixedWingLineCrew(http: HttpClient, rootUrl: string, params: MoveFixedWingLineCrew$Params, context?: HttpContext): Observable<StrictHttpResponse<FixedWingLinesResponse>> {
  const rb = new RequestBuilder(rootUrl, moveFixedWingLineCrew.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FixedWingLinesResponse>;
    })
  );
}

moveFixedWingLineCrew.PATH = '/api/scheduler/daily-line-schedule/fixed-wing/lines/{id}/move-crew';
